import * as acc from "../libraries/accessibility";

document.addEventListener('click', e => {
  if (e.target.matches('#btn-relief-center')) {
    acc.goToPage();
  }
})
